import { useExtensionsSetupRegistryForPatient } from '../../../hooks/useExtensions';

export function ExtensionsMainPatient(): null {
  useExtensionsSetupRegistryForPatient();
  return null;
}
